// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// ICONS
import { HiChevronRight } from 'react-icons/hi';
import { BiSearchAlt2 } from 'react-icons/bi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import ActionStrip from '../../../components/ActionStrip';
import InputBlock from '../../../components/InputBlock';
import Button from '../../../components/Button';

const JobListBlock = (props) => {
  const { jobs, setSelectedJobId, setSelectedJobNumber } = props;
  const [allJobsVisible, setAllJobsVisible] = useState(false);
  const [jobsToShow, setJobsToShow] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (jobs.length > 0) {
      const userJobs = jobs.filter((job) => job.isUserPartOfJob);

      if (userJobs.length === 0) {
        setSelectedJobId(jobs[0].id);
        setSelectedJobNumber(jobs[0].projectNumber);
        setAllJobsVisible(true);
      } else {
        setSelectedJobId(userJobs[0].id);
        setSelectedJobNumber(userJobs[0].projectNumber);
      }
    }
  }, [jobs]);

  useEffect(() => {
    searchJobs();
  }, [searchTerm, jobs]);

  const searchJobs = () => {
    const normalizedSearchTerm = searchTerm.trim().toLowerCase();

    if (!normalizedSearchTerm) {
      setJobsToShow(jobs);
      return;
    }

    const filteredJobs = jobs.filter((job) => {
      const projectNumber = String(job.projectNumber || '').toLowerCase();
      const projectName = String(job.projectName || '').toLowerCase();

      return projectNumber.includes(normalizedSearchTerm) || projectName.includes(normalizedSearchTerm);
    });

    setJobsToShow(filteredJobs);
  };

  const getJobTitle = (job) => {
    if (!job.projectName) {
      return `#${job.projectNumber}`;
    }

    return `#${job.projectNumber} — ${job.projectName}`;
  };

  return (
    <>
      <CustomBlock className='job-list-block-container h-100'>
        <CustomBlock className='job-list-block-header'>
          <CustomBlock className='header-block'>
            <CustomBlock>
              <ContentHeader title='Jobs' headerSize='md' textHeaderStyle='pb-0' className='mb-0 pb-0' />
            </CustomBlock>

            <CustomBlock>
              <Button
                text={allJobsVisible ? 'Show Only My Jobs' : 'View All Jobs'}
                className='primary--bg mr-0'
                size='xxs'
                onClick={() => setAllJobsVisible(!allJobsVisible)}
              />
            </CustomBlock>
          </CustomBlock>

          <CustomBlock className='search-block my-6'>
            <InputBlock
              placeholder='Search Job Numbers'
              unpadded
              onChange={(event) => setSearchTerm(event.target.value)}
              iconLeft={<BiSearchAlt2 size={20} className='grey--clr' />}
            />
          </CustomBlock>
        </CustomBlock>

        <CustomBlock className='job-list-block'>
          {!allJobsVisible &&
            jobsToShow
              .filter((job) => job.isUserPartOfJob)
              .map((job) => (
                <ActionStrip
                  key={job.id}
                  title={
                    <div className='d-flex flex-column'>
                      <span className='font-weight-bold'>#{job.projectNumber}</span>

                      {job.projectName && <span className='font-weight-normal text-muted'>{job.projectName}</span>}
                    </div>
                  }
                  rightActionText='Details'
                  rightActionIcon={<HiChevronRight size={25} />}
                  backgroundColor='lighter--bg'
                  rightActionTo={`/services/manage-job/general-information/${job.id}`}
                />
              ))}

          {allJobsVisible &&
            jobsToShow.map((job) => (
              <ActionStrip
                key={job.id}
                title={
                  <div className='d-flex flex-column'>
                    <span className='font-weight-bold'>#{job.projectNumber}</span>

                    {job.projectName && <span className='font-weight-normal text-muted'>{job.projectName}</span>}
                  </div>
                }
                rightActionText='Details'
                rightActionIcon={<HiChevronRight size={25} />}
                backgroundColor='lighter--bg'
                rightActionTo={`/services/manage-job/general-information/${job.id}`}
                highlighted={job.isUserPartOfJob}
              />
            ))}
        </CustomBlock>
      </CustomBlock>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(JobListBlock);
